export default {
    isLog
}

function isLog(){
    return false;
}